export default __webpack_public_path__ + "static/media/loginlogo.bc53ba15.png";